import React from 'react'
import GaugeChart, { CenterSection, GaugeData } from 'components/visualization/Gauge'
import {
  MetricItemContainer,
  Legend,
  LegendProps,
  MetricItemContainerProps
} from '../share/components'
import { isValidNumber } from '../share/utils'

export interface GaugeMetricItemProps {
  data: GaugeData[]
  chartOptions: {
    yAxisMin?: number
    yAxisMax?: number
    yAxisLabelFormatter?: (value: number) => string
    centerSection: Omit<CenterSection, 'type'>
    colorSettings: Record<string, string>
  }
  legendOptions: Partial<Omit<LegendProps, 'isDisplayPercent'>> & { isShowLegend: boolean }
  disabledInfo?: MetricItemContainerProps['disabledInfo']
  explanation: MetricItemContainerProps['explanation']
}

const GaugeMetricItem = ({
  data,
  chartOptions,
  legendOptions,
  disabledInfo = {
    isDisabled: false
  },
  explanation
}: GaugeMetricItemProps) => (
  <MetricItemContainer disabledInfo={disabledInfo} explanation={explanation}>
    <GaugeChart
      data={data.map((d) => ({ ...d, y: isValidNumber(d.y) ? d.y : 0 }))}
      size="234px"
      yAxisMin={chartOptions.yAxisMin}
      yAxisMax={chartOptions.yAxisMax}
      yAxisLabelFormatter={chartOptions.yAxisLabelFormatter}
      centerSection={{
        type: 'summary',
        ...chartOptions.centerSection
      }}
      colorSettings={chartOptions.colorSettings}
    />
    {legendOptions.isShowLegend && (
      <Legend
        data={legendOptions.data || data}
        colorSettings={legendOptions.colorSettings || chartOptions.colorSettings}
        isDisplayPercent={false}
      />
    )}
  </MetricItemContainer>
)

export default GaugeMetricItem
